import { GeoDsDocument } from './document.model';
import { GeoDsMeta } from './meta-data.model';

export class Person extends GeoDsMeta {
  FirstName: string;
  LastName: string;
  Sex: string;
  Address: string;
  Birthday: Date;
  City: string;
  EMail: string;
  Country: string;
  Department: string;
  PrivatePhone: string;
  Function: string;
  Login: string;
  PersonnelNumber: string;
  Title: string;
  ParentId: string;
  Active: boolean;
  ProjectManager: boolean;
  OfficeLocation: string;
  Status: string;
  Reserve1: string;
  Reserve2: string;
  Reserve3: string;
  Reserve4: string;
  Reserve5: string;
  Salutation: string;
  SelectionFunction?: boolean;
  Documents?: GeoDsDocument[];
  IdRefDepartment: string;
  OfficePhone?:string;
  MainContact?: boolean;
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
